(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ds-product-question"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-question-open]');
    if (trigger) document.getElementById(trigger.dataset.questionOpen)?.showModal();
    const close = event.target.closest('[data-question-close]');
    if (close) close.closest('dialog').close();
    if (event.target.matches('dialog.ds-question')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.querySelectorAll('.ds-question').forEach((dialog) => {
    dialog.addEventListener('close', () => document.querySelector(`[data-question-open="${dialog.id}"]`)?.focus());
    if (dialog.querySelector('[data-question-result]')) dialog.showModal();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ds-product-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ds-product-video')) {
    customElements.define('ds-product-video', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('button');
        if (!button || this.dataset.bound) return;
        this.dataset.bound = 'true';
        button.addEventListener('click', () => {
          const id = this.dataset.videoId;
          if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
          const start = Math.min(86400, Math.max(0, Math.floor(Number(this.dataset.start) || 0)));
          const player = document.createElement('iframe');
          player.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&playsinline=1&start=${start}`;
          player.title = this.dataset.title;
          player.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          player.allowFullscreen = true;
          player.referrerPolicy = 'strict-origin-when-cross-origin';
          this.replaceChildren(player);
          player.focus();
        }, { once: true });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ds-review-sources"] && !Shopify.designMode) return;
  try {
    (() => {
    const prefix = document.querySelector('[data-ds-review-source-prefix]')?.textContent;
    if (!prefix) return;
    const formatSources = () => {
      document.querySelectorAll('#judgeme_product_reviews .jm-review-item').forEach((review) => {
        const answers = [...review.querySelectorAll('.jm-text-answer')];
        const continuation = answers.find((entry) => entry.textContent.trim().startsWith('Review continuation'));
        const body = review.querySelector('.jdgm-review-content__body-content');
        if (continuation && body) {
          if (!body.querySelector('[data-ds-review-continuation]')) {
            const extra = document.createElement('span');
            extra.dataset.dsReviewContinuation = '';
            extra.style.whiteSpace = 'pre-wrap';
            extra.textContent = continuation.querySelector('.jdgm-ellipsis')?.textContent || continuation.textContent.slice('Review continuation'.length);
            (body.lastElementChild || body).append(extra);
          }
          continuation.hidden = true;
        }
        const source = answers.find((entry) => entry.textContent.trim().startsWith('Source') && !entry.textContent.trim().startsWith('Source URL'));
        const url = answers.find((entry) => entry.textContent.trim().startsWith('Source URL'));
        const originalId = answers.find((entry) => entry.textContent.trim().startsWith('Original review ID'));
        if (originalId && !originalId.hidden) originalId.hidden = true;
        if (!source || !url) return;
        const name = source.textContent.trim().slice('Source'.length).trim();
        const address = url.textContent.trim().slice('Source URL'.length).trim();
        let parsed;
        try { parsed = new URL(address); } catch { return; }
        if (!name || parsed.protocol !== 'https:') return;
        if (!review.querySelector('.ds-review-source')) {
          const line = document.createElement('p');
          line.className = 'ds-review-source';
          line.append(document.createTextNode(`${prefix} `));
          const link = document.createElement('a');
          link.href = parsed.href;
          link.textContent = name;
          link.target = '_blank';
          link.rel = 'nofollow noopener';
          line.append(link);
          source.parentElement.append(line);
        }
        if (!source.hidden) source.hidden = true;
        if (!url.hidden) url.hidden = true;
      });
    };
    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; formatSources(); });
    });
    const start = () => {
      const widget = document.getElementById('judgeme_product_reviews');
      if (!widget) return;
      formatSources();
      observer.observe(widget, { childList: true, subtree: true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
    document.addEventListener('shopify:section:load', start);
  })();
  } catch(e) { console.error(e); }
})();

})();
